module.exports = __webpack_public_path__ + "static/media/r27.4fd9d6fb.jpg";